import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Autoplay, Navigation, Pagination } from 'swiper';

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/pagination/pagination.min.css";

import { isMobile } from "react-device-detect";

function ClothingCollection({ componentData, getTargetUrl }) {
  const navigation_status = isMobile? false:true;  
  const slide_per_view = isMobile?1:3;
  // var settings = {
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow:
  //     componentData?.data?.length >= 4 ? 4 : componentData.data?.length || 1,
  //   slidesToScroll: 1,
  //   initialSlide: 0,
  //   cssEase: "linear",
  //   mobileFirst: true,
  //   centerMode: true,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow:
  //           componentData?.data?.length >= 4
  //             ? 4
  //             : componentData.data?.length || 1,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: true,
  //       },
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         initialSlide: 0,
  //         dots: true
  //       },
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         dots: true
  //       },
  //     },
  //   ],
  // };

  return (
    <>    
    <section className="us-clothing-section">
          <div className="us-section-heading-area">
            <h2 className="us-heading">Clothing Collection</h2>
            <p className="us-subheading">
                Discover endless style possibilities with our luxury fashion assortments
            </p>
          </div>

          <div className="us-clothing-grid">
          {componentData.data?.map((data, index) => {
              return (                
                <Link to={getTargetUrl(data)} className="us-clothing-item">
                  <div className="img-area">
                    <LazyLoadImage
                        alt={""}
                        effect="blur"
                        src={data.src || ""}
                        className="img-fluid mx-auto d-block"
                      />                    
                  </div>
                  <div className="content-area">
                    <h2 className="title">{data?.title || ""}</h2>
                    <p className="sub-title">
                      {data?.subtitle || ""}
                    </p>
                  </div>
                </Link>
              );
            })}                        
          </div>
        </section>
    </>
  );
}

export default ClothingCollection;
